
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
axios.defaults.withCredentials = true

import '../css/style.css'
import '../common/css/reset.css'


new Vue({
    el: '#app',
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main/resources/static/js/index.js